import {
  Stepper as BaseStepper,
  styled,
  Grid as GridBase,
  StepLabel as BaseStepLabel,
  Box,
} from "@mui/material";

export const FormContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(4, 0),
}));

export const GridContainer = styled((props) => (
  <GridBase {...props} container />
))`
  &.MuiGrid-container {
    margin: ${(props) => props.margin || "0"};
    gap: ${(props) => props.spacing || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const MerchantAndTerminalsFormRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;
export const AddTerminalContainer = styled((props) => (
  <GridBase {...props} item />
))`
  &.MuiGrid-item {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
`;

export const Stepper = styled(BaseStepper)(({ theme }) => ({
  backgroundColor: theme.palette.blokko.taglineMist,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2, 4),
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2, 2),
  },
}));

export const StepLabel = styled((props) => <BaseStepLabel {...props} />)`
  color: ${(props) => props.color || "text.secondary"};
  font-weight: ${(props) => props.fontWeight || "normal"};
`;

export const FormActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: theme.spacing(3),
}));

export const FileUploadContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

export const OwnersHeaderContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const OwnersActionsContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));
